<template>
  <div class="return-container has-no-style" v-show="!hideBackButton">
    <div
      class="return-inner verticallyCenter style-wrap"
      ref="returnInner"
      @click.stop.prevent
      :style="getTextStyle"
      @click="textClickEvent"
    >
      <span v-if="iconType === 'icon' && iconSrc" :class="iconSrc" :style="getIconStyle"></span>
      <img v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
      <span v-show="showReturnText">{{ getTextContent }}</span>
    </div>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import { replaceUrlParam } from "utils/index"
export default {
  mixins: [eventMixin],
  name: "cxButton",
  props: {
    type: { type: String },
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      hideBackButton: false
    }
  },
  computed: {
    getTextContent() {
      return this.options ? this.options.content : null
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    getMargin() {
      return this.options.iconPosition === "left"
        ? `0 ${this.options.iconMargin}px 0 0`
        : `0 0 0 ${this.options.iconMargin}px`
    },
    getIconStyle() {
      return {
        color: this.options.iconColorIsThemeColor ? this.themeColor : this.color,
        fontSize: this.options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    getIconImgStyle() {
      return {
        width: this.options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    getTextStyle() {
      if (this.options) {
        let borderW = ""
        if (Array.isArray(this.options.borderWidth)) {
          this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${this.options.borderWidth}px`
        }
        let thisStyle = {
          height: `${this.options.height}px`,
          "font-style": `${this.options.fontStyle}`,
          "font-family": this.options.fontFamily,
          opacity: this.options.opacity,
          // color: this.options.textIsThemeColor ? this.themeColor : this.options.color,
          color: this.$parseColor(this.options.color, {
            isThemeColor: this.options.textIsThemeColor
          }),
          "font-size": this.options.fontSize + "px",
          "font-weight": this.options.fontWeight,
          "text-decoration": this.options.textDecoration,
          transform: "rotate(" + this.options.rotate + "deg)",
          "border-top-left-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderTopLeftRadius + "px",
          "border-top-right-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderTopRightRadius + "px",
          "border-bottom-left-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderBottomLeftRadius + "px",
          "border-bottom-right-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderBottomRightRadius + "px",
          cursor: this.isBigScreenPreview() ? "pointer" : ""
        }
        return {
          ...this.bgStyle,
          ...thisStyle
        }
      } else return null
    },
    showReturnText() {
      return this.options ? this.options.showReturnText : true
    }
  },
  created() {
    let hide = this.options.hasOwnProperty("hideBackButton") ? this.options.hideBackButton : false
    if(hide){
      if(window.history.length <= 1){
        // 跳转设置为新页面打开
        this.hideBackButton = true
      } else if(document.referrer === ""){
        // 复制预览地址直接打开
        this.hideBackButton = true
      } else if (performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD &&
          performance.navigation.redirectCount === 0) {
        // 是通过 history.go(-1) 进入页面的
        // performance.navigation 在某些浏览器中可能不可用或者不完整: chrome4-9,safari3.1-7.1,firfox2-6,opera10-12.1,ie6-8,
        this.hideBackButton = true
      } else {
        this.hideBackButton = false
      }
    }
  },
  methods: {
    textClickEvent() {
      // 预览页面使用
      if (!this.isBigScreenPreview()) {
        return
      }
      // window.localStorage.getItem("returnPageId", selectName?.length ? data + "###" + selectName : data)
      // const newUrl = replaceUrlParam(window.previewUrl || window.location.href, "p", this.homePageId)
      // window.location.href = newUrl
      history.go(-1)
      // if(document.referrer.includes('v2/p')) {
      //   history.go(-1)
      // } else {
      //   history.go(-2)
      // }
    }
  }
}
</script>

<style scoped>
.cx-button {
  position: relative;
  line-height: 100%;
  pointer-events: none;
}
.return-inner {
  position: absolute;
  width: 100%;
  text-align: center;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.6), 0px 9px 28px rgba(0, 0, 0, 0.3),
    0px 12px 48px 16px rgba(0, 0, 0, 0.2);
}
.verticallyCenter {
  justify-content: center;
}
</style>
